import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";
import API from "../utils/API";
import "../../src/App.css";
import { useHistory } from "react-router-dom";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport variant="contained" color="secondary" />
    </GridToolbarContainer>
  );
}

const WalletReport =() =>{
  const history = useHistory();

  const [listView, setUserDate] = useState({});

  const [startDateB, setStartDate] = useState("");
  const [endDateB, setEndDate] = useState("");

  const [startDateFromButtonClick, setStartDateFromButtonClick] = useState();

  const [endDateFromButtonClick, setEndDateFromButtonClick] = useState();

  const [loading, setLoading] = useState(false);

  const options = { month: "long", day: "numeric", year: "numeric" };

  const dateFormatter = new Intl.DateTimeFormat("en-GB", options);

  const columns = [
    { field: "id" , headerName: "ID", width: 100 , },
    { field: "name", headerName: "Name", width: 250 },
    { field: "customerId", headerName: " Customer ID", width: 150 },
    { field: "transactionId", headerName: "Token No", width: 270 },
    { field: "credit", headerName: "Credit", width: 150 },
    { field: "debit", headerName: "Debit", width: 150 },
    { field: "mobile", headerName: "Mobile", width: 170 },
    { field: "email", headerName: "Email", width: 170 },
    {
      field: "transactionDate",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => dateFormatter.format(new Date(value)),
    },
    { field: "transactionTypeName", headerName: "Type Name", width: 150 },
  ];

  const handleClick = () => {
    setLoading(!loading);
    setStartDateFromButtonClick(startDateB);
    setEndDateFromButtonClick(endDateB);
    setUserDate({});
  };

  useEffect(() => {
    function daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    }

    var today = new Date();

    let month = today.getMonth() + 1;
    let year = today.getFullYear();

    let lastdate = daysInMonth(today.getMonth() + 1, today.getFullYear());
    if (month !== 10 && month !== 11 && month !== 12) {
      month = `0${month}`;
    }
    const start = `${year}-${month}-01`;
    const end = `${year}-${month}-${lastdate}`;
    console.log(start);
    console.log(end);

    setStartDate(start);
    setEndDate(end);
  }, []);

  useEffect(() => {
    const storedToken = localStorage.getItem("tokenStore");

    if (!storedToken) {
      history.push("/");
    }

    if (startDateB !== "" && endDateB !== "") {
      API({
        url: `/customer-wallet-details?startDate=${startDateFromButtonClick}&endDate=${endDateFromButtonClick}`,
        headers: { Authorization: `Bearer ${storedToken}` },
      })
        .then((res) => {
          setLoading(false);
          setUserDate(res.data);
          console.log(res.data);
        })

        .catch((err) => {
          console.log(err);
        });
    }

    // eslint-disable-next-line
  }, [startDateFromButtonClick, endDateFromButtonClick, loading]);

  return (
    <Box alignItems="center" style={{ width: "87%", marginLeft: "15rem" }}>
      <div>
        <form noValidate onSubmit={(e) => e.preventDefault()}>
          <TextField
            onChange={(e) => setStartDate(e.target.value)}
            id="date"
            label="Start Date"
            type="date"
            style={{ transform: "translate(-15%,-20%)" }}
            InputLabelProps={{ shrink: true }}
            value={startDateB}
          />

          <TextField
            id="date"
            label="End Date"
            type="date"
            style={{ transform: "translate(8%,-20%)" }}
            InputLabelProps={{ shrink: true }}
            value={endDateB}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <br />

          <Button
            type="submit"
            style={{
              padding: "4px",
              margin: "5px",
              marginTop: "20px",
            }}
            variant="contained"
            color="primary"
            onClick={handleClick}
          >
            Submit
          </Button>
        </form>
        <br />

        <div
          style={{
            height: 400,
            width: "90%",
            background: "transparent",
            color: "black",
            marginTop: 20,
            marginLeft: 10,
          }}
        >
          {listView.length > 0 && (
            <DataGrid
              rows={listView}
              columns={columns}
              pageSize={10}
              sortModel={[
                {
                  field: "id",
                  sort: "desc",
                },
              ]}
              components={{
                Toolbar: CustomToolbar,
              }}
            />
          )}

          {loading ? <CircularProgress style={{ marginTop: 50 }} /> : ""}
        </div>
      </div>
    </Box>
  );
}

export default WalletReport;





  //  const calculateWalletBalance=(data)=>{
  //    let customerWalletList={};
  //     for(let i in data){
  //       customerWalletList=data[i].customerWalletModels;

  //       for(let j in data[i].customerWalletModels){
  //         console.log(data[i].customerWalletModels[j].credit)
  //         console.log(data[i].customerWalletModels[j].debit)
  //         console.log(data[i].customerWalletModels[j].totalBalance)

  // if(data[i].customerWalletModels[j].credit <20){
  //   console.log("null amount")
  // }
  //       }
  //     }

  // }